<template>
  <div class="images" :class="data.style.template">
    <template v-if="data.style.template==='template1'">
      <div
        class="img"
        v-for="(item,index) in data.images"
        :key="index">
        <img
          :src="item.src"
          :style="{marginTop:index>0?data.style.spacing+'px':0}">
      </div>
    </template>
    <template v-if="data.style.template==='template2'">
      <div
        class="img"
        v-for="(item,index) in data.images"
        :key="index"
        :style="{width:(300-style.padding*2)/2-data.style.spacing/2+'px',marginRight:index%2===0?data.style.spacing+'px':0,marginTop:index>1?data.style.spacing+'px':0}">
        <img :src="item.src">
      </div>
    </template>
    <template v-if="data.style.template==='template3'">
      <div
        class="img"
        v-for="(item,index) in data.images"
        :key="index"
        :style="{width:(300-style.padding*2)/3-data.style.spacing*2/3+'px',marginRight:(index+1)%3!==0?data.style.spacing+'px':0,marginTop:index>2?data.style.spacing+'px':0}">
        <img :src="item.src">
      </div>
    </template>
    <template v-if="data.style.template==='template4'">
      <div
        class="img"
        v-for="(item,index) in data.images"
        :key="index"
        :style="{width:(300-style.padding*2)/4-data.style.spacing*3/4+'px',marginRight:(index+1)%4!==0?data.style.spacing+'px':0,marginTop:index>3?data.style.spacing+'px':0}">
        <img :src="item.src">
      </div>
    </template>
    <template v-if="data.style.template==='template5'">
      <div
        class="img">
        <img
          v-for="(item,index) in data.images"
          :key="index"
          :src="item.src"
          :style="{marginRight:index+1===data.images.length?0:data.style.spacing+'px'}">
      </div>
    </template>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'images',
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    style () {
      return this.$store.state.page.style
    }
  }
}
</script>
<style lang="less" scoped>
.template1 {
  .img {
    width: 100%;
    overflow: hidden;
  }
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
.template2, .template3, .template4 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
.template5 {
  height: 90px;
  overflow: hidden;
  .img {
    height: 100%;
    width: 300%;
  }
  img {
    display: block;
    width: auto;
    height: 100%;
    float: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/components/modules/images.vue